export default __webpack_public_path__ + "14b13c31dd6423c2c80c453445415342.png";